exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_PicaButton__11dKo {\n  display: inline-block; }\n  .styles_PicaButton__11dKo a {\n    display: block;\n    padding: 2px 10px 0;\n    text-align: center;\n    margin: auto;\n    border: 1px solid #000;\n    color: #000;\n    font: 700 1.4em \"MabryPro\", sans-serif;\n    text-transform: uppercase;\n    line-height: 2em; }\n  .styles_PicaButton__11dKo + .styles_PicaButton__11dKo {\n    margin-left: 10px; }\n", ""]);

// Exports
exports.locals = {
	"PicaButton": "styles_PicaButton__11dKo"
};